// Lucsartech website — interactive bits: demo modal, mobile menu, scroll-shadow,
// lang menu, UTM capture, cookie consent + GA4 loader.

(() => {
	const q  = (sel, ctx = document) => ctx.querySelector(sel);
	const qa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

	// ---------------------------------------------------------------
	// UTM tracking — capture once from URL, keep for 30 days so a user
	// who arrives via an ad campaign and converts later still carries the
	// source attribution on the form submission.
	// ---------------------------------------------------------------
	const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
	const UTM_COOKIE = 'lucs_utm';
	const UTM_TTL_DAYS = 30;

	function setCookie(name, value, days) {
		const exp = new Date(Date.now() + days * 86400 * 1000).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax`;
	}
	function getCookie(name) {
		const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
		return m ? decodeURIComponent(m[1]) : null;
	}

	function captureUtmFromUrl() {
		const params = new URLSearchParams(window.location.search);
		const captured = {};
		for (const k of UTM_KEYS) {
			const v = params.get(k);
			if (v) captured[k] = v.slice(0, 140);
		}
		if (Object.keys(captured).length) {
			captured._at = Date.now();
			setCookie(UTM_COOKIE, JSON.stringify(captured), UTM_TTL_DAYS);
			return captured;
		}
		try {
			return JSON.parse(getCookie(UTM_COOKIE) || '{}');
		} catch (_e) {
			return {};
		}
	}

	const utmPayload = captureUtmFromUrl();
	function mergeTracking(payload) {
		for (const k of UTM_KEYS) if (utmPayload[k]) payload[k] = utmPayload[k];
		payload.referer_url = (document.referrer || '').slice(0, 140);
		return payload;
	}

	// ---------------------------------------------------------------
	// Cookie consent banner + GA4 consent update
	// ---------------------------------------------------------------
	const CONSENT_COOKIE = 'lucs_cookie_consent';
	const banner = q('[data-lucs-cookie-banner]');
	const gtag = window.gtag || function () { (window.dataLayer = window.dataLayer || []).push(arguments); };

	function applyConsent(accepted) {
		setCookie(CONSENT_COOKIE, accepted ? 'accepted' : 'rejected', 365);
		if (banner) banner.classList.remove('is-open');
		if (window.LUCS_GA4_ID) {
			gtag('consent', 'update', {
				analytics_storage: accepted ? 'granted' : 'denied',
			});
			if (accepted) {
				gtag('config', window.LUCS_GA4_ID, { anonymize_ip: true });
			}
		}
	}

	const prior = getCookie(CONSENT_COOKIE);
	if (prior === 'accepted' && window.LUCS_GA4_ID) {
		// Silent re-grant across sessions (user already accepted)
		gtag('consent', 'update', { analytics_storage: 'granted' });
		gtag('config', window.LUCS_GA4_ID, { anonymize_ip: true });
	} else if (!prior && banner) {
		// Never decided → show banner (after a short delay to avoid CLS jank)
		setTimeout(() => banner.classList.add('is-open'), 400);
	}

	q('[data-lucs-cookie-accept]') && q('[data-lucs-cookie-accept]').addEventListener('click', () => applyConsent(true));
	q('[data-lucs-cookie-reject]') && q('[data-lucs-cookie-reject]').addEventListener('click', () => applyConsent(false));

	// Scroll-shadow on header
	const header = q('[data-lucs-header]');
	if (header) {
		const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 50);
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}

	// Mobile menu toggle
	const mobileBtn = q('[data-lucs-toggle-menu]');
	const mobileMenu = q('#mobile-menu');
	if (mobileBtn && mobileMenu) {
		mobileBtn.addEventListener('click', () => {
			const open = mobileMenu.classList.toggle('is-open');
			mobileBtn.setAttribute('aria-expanded', String(open));
		});
	}

	// Dropdowns (lang switcher + "Risorse" menu). Class-based open/close so
	// neither Frappe CSS nor the global [hidden] rule can interfere.
	const dropdownGroups = [
		{ wrap: '[data-lucs-lang]',     toggle: '[data-lucs-lang-toggle]',     menu: '[data-lucs-lang-menu]' },
		{ wrap: '[data-lucs-dropdown]', toggle: '[data-lucs-dropdown-toggle]', menu: '[data-lucs-dropdown-menu]' },
	];
	const allMenus = () => dropdownGroups.flatMap((g) => qa(g.menu));
	const allToggles = () => dropdownGroups.flatMap((g) => qa(g.toggle));

	dropdownGroups.forEach((group) => {
		qa(group.wrap).forEach((wrap) => {
			const btn = wrap.querySelector(group.toggle);
			const menu = wrap.querySelector(group.menu);
			if (!btn || !menu) return;
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				const willOpen = !menu.classList.contains('is-open');
				allMenus().forEach((m) => m.classList.remove('is-open'));
				menu.classList.toggle('is-open', willOpen);
				btn.setAttribute('aria-expanded', String(willOpen));
			});
		});
	});
	document.addEventListener('click', () => {
		allMenus().forEach((m) => m.classList.remove('is-open'));
		allToggles().forEach((b) => b.setAttribute('aria-expanded', 'false'));
	});

	// Demo modal
	const modal = q('[data-lucs-demo-modal]');
	const openers = qa('[data-lucs-open-demo]');
	const closers = qa('[data-lucs-close-demo]');
	const form = q('[data-lucs-demo-form]');
	const feedback = q('[data-lucs-demo-feedback]');
	const submitBtn = q('[data-lucs-demo-submit]');

	const openModal = () => {
		if (!modal) return;
		modal.hidden = false;
		document.body.style.overflow = 'hidden';
	};
	const closeModal = () => {
		if (!modal) return;
		modal.hidden = true;
		document.body.style.overflow = '';
	};
	openers.forEach((b) => b.addEventListener('click', openModal));
	closers.forEach((b) => b.addEventListener('click', closeModal));
	modal && modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
	document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

	// Build fetch headers: CSRF token only attached if Frappe has injected a
	// real one (authenticated users); for Guest submits we deliberately omit
	// the header so Frappe's "Guest means no CSRF" fallback applies and the
	// request isn't rejected with 400 for a bogus 'Guest' token value.
	function buildHeaders() {
		const h = { 'Content-Type': 'application/json' };
		const real = (window.frappe && window.frappe.csrf_token) || window.csrf_token;
		if (real && real !== 'Guest') h['X-Frappe-CSRF-Token'] = real;
		return h;
	}

	// Contact form (/contatti) submit
	const contactForm = q('[data-lucs-contact-form]');
	if (contactForm) {
		const cFeedback = q('[data-lucs-contact-feedback]');
		const cSubmit = q('[data-lucs-contact-submit]');
		contactForm.addEventListener('submit', async (e) => {
			e.preventDefault();
			cFeedback.textContent = '';
			cSubmit.disabled = true;
			const originalText = cSubmit.textContent;
			cSubmit.textContent = '…';

			const data = new FormData(contactForm);
			const payload = {};
			data.forEach((v, k) => (payload[k] = v));
			payload.privacy_consent = contactForm.querySelector('#c-privacy').checked ? 1 : 0;
			mergeTracking(payload);

			try {
				const res = await fetch('/api/method/lucsartech_website.api.contact.submit_contact_message', {
					method: 'POST',
					headers: buildHeaders(),
					body: JSON.stringify(payload),
				});
				const body = await res.json().catch(() => ({}));
				if (res.ok && body.message && body.message.ok) {
					contactForm.reset();
					cFeedback.className = 'text-sm text-green-700';
					cFeedback.textContent = body.message.message;
				} else {
					cFeedback.className = 'text-sm text-red-500';
					cFeedback.textContent = (body.message && body.message.message) || 'Errore. Riprova più tardi.';
				}
			} catch (_err) {
				cFeedback.className = 'text-sm text-red-500';
				cFeedback.textContent = 'Errore di rete. Riprova più tardi.';
			} finally {
				cSubmit.disabled = false;
				cSubmit.textContent = originalText;
			}
		});
	}

	// Demo submit via Frappe API endpoint
	if (form) {
		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			feedback.textContent = '';
			submitBtn.disabled = true;
			const submitLabel = submitBtn.textContent;
			submitBtn.textContent = submitBtn.dataset.loadingText || 'Invio…';

			const data = new FormData(form);
			const payload = {};
			data.forEach((v, k) => {
				if (payload[k] !== undefined) {
					payload[k] = [].concat(payload[k], v);
				} else {
					payload[k] = v;
				}
			});
			// Modules may be array or single -> always array
			if (payload.selected_modules && !Array.isArray(payload.selected_modules)) {
				payload.selected_modules = [payload.selected_modules];
			}
			payload.privacy_consent = form.querySelector('#demo-privacy').checked ? 1 : 0;
			mergeTracking(payload);

			try {
				const res = await fetch('/api/method/lucsartech_website.api.demo.submit_demo_request', {
					method: 'POST',
					headers: buildHeaders(),
					body: JSON.stringify(payload),
				});
				const body = await res.json().catch(() => ({}));
				if (res.ok && body.message && body.message.ok) {
					form.reset();
					feedback.className = 'text-sm text-green-700';
					feedback.textContent = body.message.message || 'Grazie! Ti ricontatteremo presto.';
					setTimeout(closeModal, 2500);
				} else {
					feedback.className = 'text-sm text-red-500';
					feedback.textContent = (body.message && body.message.message) || 'Errore. Riprova più tardi.';
				}
			} catch (err) {
				feedback.className = 'text-sm text-red-500';
				feedback.textContent = 'Errore di rete. Riprova più tardi.';
			} finally {
				submitBtn.disabled = false;
				submitBtn.textContent = submitLabel;
			}
		});
	}
})();
